import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';

export const useDeleteTransfer = () => {
  const { projectId } = useParams();

  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: (transferId) =>
      apiClient.delete(`/v1/projects/${projectId}/transfers/${transferId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transfers', projectId] });
    },
  });
};
